/* wk-be: toont de Belgie-elementen (btw-verlegging) alleen voor bezoekers uit BE.
   Deterministisch: op ELKE paginalading (ook terug/vooruit uit de browsercache)
   wordt de zichtbaarheid opnieuw bepaald en expliciet AAN of UIT gezet.
   ?wktest=be geldt alleen voor die ene paginalading en wordt nooit opgeslagen.
   De cache-sleutel wk_geo bevat uitsluitend het antwoord van Shopify's eigen
   geolocatie-endpoint. Fail-silent: bij twijfel of fouten is de stand UIT. */
(function () {
  var de = document.documentElement;
  var KEY = 'wk_geo';
  try { sessionStorage.removeItem('wk_country'); } catch (e) {} // oude sleutel opruimen

  function setState(on) {
    if (on) { de.classList.add('wk-be'); }
    else { de.classList.remove('wk-be'); }
  }

  function evaluate() {
    try {
      var qs = new URLSearchParams(window.location.search).get('wktest');
      if (qs === 'be') { setState(true); return; }
      setState(false); // standaard UIT, ook als een herstelde pagina de klasse nog had

      if (qs === 'nl') return;

      var cached = null;
      try { cached = sessionStorage.getItem(KEY); } catch (e) {}
      if (cached) {
        if (cached === 'BE') setState(true);
        return;
      }

      if (!window.fetch) return;
      var controller = window.AbortController ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 4000) : null;
      fetch('/browsing_context_suggestions.json', controller ? { signal: controller.signal } : {})
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          if (timer) clearTimeout(timer);
          var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
          if (!country) return;
          country = String(country).toUpperCase();
          try { sessionStorage.setItem(KEY, country); } catch (e) {}
          if (country === 'BE') setState(true);
        })
        .catch(function () {});
    } catch (e) {}
  }

  evaluate();
  // Pagina die uit de terug/vooruit-cache van de browser komt: opnieuw beoordelen
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) evaluate();
  });
})();
